var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid/Grid';
import TextField from '@material-ui/core/TextField/TextField';
import Typography from '@material-ui/core/Typography/Typography';
import React from 'react';
var ModalTemplateDeleteTextEntry = /** @class */ (function (_super) {
    __extends(ModalTemplateDeleteTextEntry, _super);
    function ModalTemplateDeleteTextEntry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { inputFieldIsValid: false };
        _this.handleChange = function (evt) {
            _this.setState({ inputFieldIsValid: !!evt.target.value && evt.target.value.toLowerCase() === 'supprimer' });
        };
        _this.handleCancel = function (evt) {
            _this.props.handleClose(evt);
        };
        _this.handleSubmit = function (evt) {
            evt.preventDefault();
            _this.props.handleSubmit();
        };
        _this.handleFormSubmit = function (evt) {
            evt.preventDefault();
            if (_this.state.inputFieldIsValid) {
                _this.props.handleSubmit();
            }
        };
        return _this;
    }
    ModalTemplateDeleteTextEntry.prototype.render = function () {
        var classes = this.props.classes || {};
        var _a = this.state, value = _a.value, inputFieldIsValid = _a.inputFieldIsValid;
        return React.createElement("div", null,
            React.createElement(Typography, { variant: "h6", className: classes.warningText }, "Attention, en supprimant votre compte et vos donn\u00E9es, tout sera effac\u00E9 et sans possibilit\u00E9 de restauration. Vous perdrez les acc\u00E8s aux services digiSchool et vos avantages premium si vous en avez."),
            React.createElement(Typography, { className: classes.warningDescription }, "Pour confirmer la suppression de votre compte, veuillez inscrire en toute lettre le mot \u00AB SUPPRIMER \u00BB dans le champ ci-dessous :"),
            React.createElement("form", { className: classes.form, noValidate: true, autoComplete: "off", onSubmit: this.handleFormSubmit },
                React.createElement(TextField, { fullWidth: true, id: "outlined-name", label: "\u00C9crivez ici", className: classes.textField, value: value, onChange: this.handleChange, margin: "normal", variant: "outlined" })),
            React.createElement(Grid, { container: true, justify: "space-between", alignItems: "center" },
                React.createElement(Grid, { item: true },
                    React.createElement(Button, { className: classes.buttonOutlined, variant: "outlined", color: "primary", onClick: this.handleCancel }, "Annuler")),
                React.createElement(Grid, { item: true },
                    React.createElement(Button, { className: classes.button, variant: "contained", color: "primary", onClick: this.handleSubmit, disabled: !inputFieldIsValid }, "Confirmer"))));
    };
    return ModalTemplateDeleteTextEntry;
}(React.Component));
export default ModalTemplateDeleteTextEntry;
//# sourceMappingURL=ModalTemplateDeleteTextEntry.js.map